<div class="select app-input" [class.select_disabled]="isDisabled" >
    <mat-select [value]="value" [disabled]="isDisabled" (selectionChange)="onChange($event)" (blur)="onBlur()">
        <!-- <mat-label>Choose an option</mat-label> -->
        <mat-option>-- Select Something --</mat-option>
        <mat-option *ngFor="let item of items" [value]=" item.cityId || item.provinceId  || item.lookupId || item.departmentId || item.industryId || item.executed || item.taggedUserId || item.templateId">
            {{ item.description || item.name || item.value || item.userName }}
        </mat-option>
    </mat-select>
</div>

